<template>
  <div>
    <tag-hero v-if="tag" :itens-count="totalRows" :tag="tag" />

    <div class="ept-container">
      <div class="w-full">
        <div class="border-b mb-8 pb-8 flex flex-col md:flex-row md:justify-center">
          <div class="w-full py-2 md:w-1/4 md:pr-2">
            <input-search v-model="form.search_term" />
          </div>

          <div class="w-full py-2 md:w-1/4 md:px-2">
            <select-single v-model="form.type" :options="typeOptions" placeholder="Todos os eixos" />
          </div>

          <div class="w-full py-2 md:w-1/4 md:px-2">
            <select-single v-model="form.period" :options="periodOptions" placeholder="Filtrar por data" />
          </div>

          <div class="w-full py-2 md:w-1/4 md:pl-2">
            <select-single v-model="form.order" :options="orderOptions" placeholder="Ordenar por" />
          </div>
        </div>

        <loading-container ref="container" :loading="loading" loading-container-class="h-64">
          <div v-if="collection.length === 0" class="h-56 w-full my-4">
            <h2 class="text-2xl ">Nenhum resultado encontrado.</h2>
            <p>Tente pesquisar novamente utilizando critérios diferentes.</p>
          </div>
          <div v-else key="content" class="w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-3 gap-5 sm:gap-10">
            <content-card class="h-auto" v-for="resource in collection" :key="`content-${resource.id}`" :resource="resource" />
          </div>
        </loading-container>

        <pagination-with-number v-if="!loading && totalRows > 0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="mb-20" />
      </div>
    </div>
  </div>
</template>

<script>
import InputSearch from 'components/form/InputSearch'
import SelectSingle from 'components/form/SelectSingle'
import LoadingContainer from 'components/shared/LoadingContainer'
import PaginationWithNumber from 'components/shared/PaginationWithNumber'
import ContentCard from 'components/contents/Card'
import TagHero from './Hero'
import {
  data as collectionData,
  methods as collectionMethod
} from 'helpers/resource/list'

export default {
  name: "ShowTag",
  components: {
    InputSearch,
    SelectSingle,
    ContentCard,
    LoadingContainer,
    PaginationWithNumber,
    TagHero
  },

  props: {
    tagId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    ...collectionData,
    form: {
      search_term: '',
      order: null,
      period: null,
      type: null,
      tag_id: null
    },
    tag: null
  }),

  watch: {
    form: {
      deep: true,
      handler() {
        this.onFilterChanges()
      }
    },
  },

  created() {
    this.form.tag_id = this.tagId
    this.fetchTag()
    this.fetchCollection()
  },

  computed: {
    typeOptions() {
      return [
        { name: 'Todos os Eixos', id: null },
        { name: 'Apenas Biblioteca', id: 'Article' },
        { name: 'Apenas Ferramentas', id: 'Tool'},
        { name: 'Apenas Dados', id: 'Indicator' }
      ]
    },
    orderOptions() {
      return [
        { name: 'Mais recente', id: null },
        { name: 'Mais antigo', id: 'most_older' }
      ]
    },

    periodOptions() {
      return [
        { name: 'Qualquer data', id: null },
        { name: 'Última semana', id: 'last_week' },
        { name: 'Último mês', id: 'last_month' },
        { name: 'Último ano', id: 'last_year' },
      ]
    },

    queryParams () {
      const form = this.form

      return {
        ...form,
        page: this.currentPage,
        per_page: this.perPage
      }
    },

    url() {
      return '/api/v1/contents/'
    }
  },

  methods: {
    ...collectionMethod,
    fetchTag(){
      this.axios.get(`/api/v1/tags/${this.tagId}`).then(({ data }) => {
        this.tag = data
      }).catch(() => {
        this.tag = {}
      })
    }
  }
}
</script>
